import { useTranslation } from 'next-i18next'

const STAR_SLOTS = [0, 1, 2, 3, 4] as const

const SIZE_CLASS = {
  sm: 'gap-px text-[12px]',
  lg: 'gap-1 text-[28px]'
} as const

type IProps = {
  rating: number
  size?: keyof typeof SIZE_CLASS
  className?: string
}

/**
 * Read-only 0–5 star strip. Brand blue on the filled glyphs (same as the
 * listing header's ★ rating), an `ink-100/20` ghost for the rest, and ONE
 * accessible name for the whole strip ("4 de 5 estrellas") instead of five
 * unlabeled icons. Renders on the SSR listing page — `common` is loaded there,
 * on profiles and on checkout details.
 */
export default function ReviewStars({
  rating,
  size = 'sm',
  className
}: IProps) {
  const { t } = useTranslation('common')
  return (
    <span
      role="img"
      aria-label={t('REVIEWS.STARS_LABEL', { rating })}
      className={`inline-flex items-center ${SIZE_CLASS[size]} ${className ?? ''}`}
    >
      {STAR_SLOTS.map((slot) => (
        <i
          key={slot}
          aria-hidden="true"
          className={`si si-star leading-none ${slot < rating ? 'text-blue-500' : 'text-ink-100/20'}`}
        />
      ))}
    </span>
  )
}
